import { Dialog, DialogTitle, Button, DialogActions} from "@mui/material";
const ConfirmationPopup = ({openDeleteModal, handleOnDeleteClick, handleCloseDeleteConfirmationModal, isLoading, messageHeading, messageBody,loadingMessage}) => {
    return (
        <Dialog open={openDeleteModal}>
            <DialogTitle id="alert-dialog-title">
                <p id="warining-message">{messageHeading}</p><hr />
                {messageBody}
            </DialogTitle>
            <DialogActions>
                <Button id="button-yes" onClick={()=>handleOnDeleteClick()} disabled={isLoading} >
                  {isLoading ? (loadingMessage?loadingMessage:"Deleting...") : "Yes"}
                </Button>
                <Button id="button-no" onClick={()=>handleCloseDeleteConfirmationModal()} disabled={isLoading}>
                    No
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmationPopup;